import { render, staticRenderFns } from "./SimilarityList.vue?vue&type=template&id=ad32516e"
import script from "./SimilarityList.vue?vue&type=script&lang=js"
export * from "./SimilarityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports